import { render, staticRenderFns } from "./RegisterFinish.vue?vue&type=template&id=07d5b810&"
import script from "./RegisterFinish.vue?vue&type=script&lang=js&"
export * from "./RegisterFinish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports